import { createSlice } from '@reduxjs/toolkit'
import { MountpointItem, MountpointMap } from 'api'

const { actions, reducer: rinexReducer } = createSlice({
  name: 'rinex',
  initialState: {
    mountpoints: [] as MountpointMap[],
    selectedMountpoint: null as MountpointItem | null,
  },
  reducers: {
    //mountpoints
    setMountpoints: (state, action) => {
      state.mountpoints = action.payload
    },
    //selectedMountpoint
    setSelectedMountpoint: (state, action) => {
      state.selectedMountpoint = action.payload
    },
    clearSelectedMountpoint: (state) => {
      state.selectedMountpoint = null
    },
  },
})

export const { setMountpoints, setSelectedMountpoint, clearSelectedMountpoint } = actions

export default rinexReducer
